module.exports = __webpack_public_path__ + "img/2.d066ca5e.png";